module.exports = __webpack_public_path__ + "assets/hubspot.2b01a687.svg";